import { MoreButton } from '@sales-center/components'
import * as React from 'react'
import { useMenu } from './hooks/useMenu'
import { IImport } from '@user/store/import/typings'

export function ActionsMenu(props: IImport) {
  const { status } = props

  const { actionMenuOptions } = useMenu(props)

  const disabled = status === 'Processing' || status === 'NotStarted'

  return (
    <MoreButton
      dataTestId={`importMoreBtn-${props.id}`}
      options={actionMenuOptions}
      disabled={disabled}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      style={{ height: '100%' }}
    />
  )
}
